module.exports = __webpack_public_path__ + "img/GH-kyujin-top-035.f568a8f5.webp";